import axios from "axios";

async function logUserLogin(userId: string, idToken: string) {
  try {
    await axios.get(
      `${process.env.REACT_APP_URL_API}/v1/users/${userId}/login`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );
  } catch (err: any) {
    console.log(err);
  }
}

export default logUserLogin;
